import { render, staticRenderFns } from "./CoeCourseGroupDetail.vue?vue&type=template&id=08d44d96"
import script from "./CoeCourseGroupDetail.vue?vue&type=script&lang=js"
export * from "./CoeCourseGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./CoeCourseGroupDetail.vue?vue&type=style&index=0&id=08d44d96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports